import { Footer } from '@domgen/base-design-system-2.0/atoms/Footer';
import { HeaderCobranded } from '@domgen/base-design-system-2.0/atoms/HeaderCobranded';
import { Outlet } from 'react-router-dom';

import clientLogo from './assets/icons/clientLogo.svg';
import dandgLogo from './assets/icons/powered-by-domestic-and-general.svg';

const Layout = () => {
  return (
    <div className="bg-neutral-200 min-h-screen flex flex-col justify-between">
      <HeaderCobranded
        clientIcon={clientLogo}
        clientUrl="/"
        dandgLogo={dandgLogo}
        clientName={import.meta.env.VITE_CLIENT_FRIENDLY_NAME}
      />
      <Outlet />
      <Footer clientName={import.meta.env.VITE_CLIENT_FRIENDLY_NAME} />
    </div>
  );
};
export default Layout;
